// extracted by mini-css-extract-plugin
var _1 = "pageHeader-module_headElement_uxtpo";
var _2 = "pageHeader-module_pageHeaderWrap_KOVcY";
var _3 = "pageHeader-module_textElement_L_buE";
export { _1 as "headElement", _2 as "pageHeaderWrap", _3 as "textElement" }
